import { render } from "./TheCartResult.vue?vue&type=template&id=64ffb6c0"
import script from "./TheCartResult.vue?vue&type=script&lang=js"
export * from "./TheCartResult.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__